<template>
  <section class="contact-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">我们期待与您合作，共同创造美好未来</p>
      </div>

      <div class="contact-content">
        <div class="contact-info">
          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-location"></i>
            </div>
            <div class="info-content">
              <h4>公司地址</h4>
              <p>{{ companyInfo ? companyInfo.address : '上海市浦东新区张江高科技园区' }}</p>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-phone"></i>
            </div>
            <div class="info-content">
              <h4>联系电话</h4>
              <p>{{ companyInfo ? companyInfo.phone : '021-12345678' }}</p>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-message"></i>
            </div>
            <div class="info-content">
              <h4>邮箱地址</h4>
              <p>{{ companyInfo ? companyInfo.email : 'contact@qzctech.com' }}</p>
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-link"></i>
            </div>
            <div class="info-content">
              <h4>官方网站</h4>
              <p>{{ companyInfo ? companyInfo.website : 'www.qzctech.com' }}</p>
            </div>
          </div>
        </div>

        <div class="contact-form">
          <h3>在线留言</h3>
          <el-form
            :model="contactForm"
            :rules="formRules"
            ref="contactForm"
            label-width="80px"
            @submit.native.prevent="submitForm"
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="contactForm.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input v-model="contactForm.email" placeholder="请输入您的邮箱"></el-input>
            </el-form-item>

            <el-form-item label="电话" prop="phone">
              <el-input v-model="contactForm.phone" placeholder="请输入您的电话"></el-input>
            </el-form-item>

            <el-form-item label="公司" prop="company">
              <el-input v-model="contactForm.company" placeholder="请输入您的公司名称"></el-input>
            </el-form-item>

            <el-form-item label="主题" prop="subject">
              <el-input v-model="contactForm.subject" placeholder="请输入留言主题"></el-input>
            </el-form-item>

            <el-form-item label="留言" prop="message">
              <el-input
                type="textarea"
                v-model="contactForm.message"
                :rows="4"
                placeholder="请输入您的留言内容"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                size="large"
                :loading="submitting"
                @click="submitForm"
              >
                {{ submitting ? '提交中...' : '提交留言' }}
              </el-button>
              <el-button size="large" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api'

export default {
  name: 'ContactSection',
  data () {
    return {
      contactForm: {
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
          { min: 10, message: '留言内容至少10个字符', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapState(['companyInfo'])
  },
  methods: {
    async submitForm () {
      try {
        await this.$refs.contactForm.validate()
        this.submitting = true

        await api.submitContactMessage(this.contactForm)

        this.$message.success('留言提交成功，我们会尽快回复您！')
        this.resetForm()
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    resetForm () {
      this.$refs.contactForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: $text-secondary;
  max-width: 600px;
  margin: 0 auto;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  background: white;
  border-radius: $border-radius-large;
  box-shadow: $box-shadow-base;
  transition: $transition-base;

  &:hover {
    transform: translateY(-2px);
    box-shadow: $box-shadow-light;
  }
}

.info-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, $primary-color, lighten($primary-color, 20%));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 20px;
    color: white;
  }
}

.info-content {
  h4 {
    font-size: 1.1rem;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.95rem;
    color: $text-secondary;
    line-height: 1.6;
  }
}

.contact-form {
  background: white;
  padding: 40px;
  border-radius: $border-radius-large;
  box-shadow: $box-shadow-base;

  h3 {
    font-size: 1.3rem;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: 24px;
    text-align: center;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .contact-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 2rem;
  }

  .contact-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .contact-form {
    padding: 24px;
  }
}
</style>
